<div class="modal-header upgrade-workspace-modal-header">
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" (click)="close()"
       style="margin: 0 0 -3rem auto; cursor: pointer">
  <img style="width: 20rem;" src="../../../assets/images/hurray.png">
  <h3 class="title"
      style="color: #00194A; margin-top: .7rem; font-size: 2.2rem; font-family: Poppins, sans-serif">{{'workspace_upgraded_modal_title' | translate}}</h3>
</div>
<div class="modal-body upgrade-workspace-modal-body">
  <img class="upgrade-workspace-checkmark" src="../../../assets/svg/hurray-green-checkmark.svg">
  <h3 style="font-size: 2.2rem; color:white; font-weight: 400;">{{'workspace_upgraded_modal_unlocked' | translate}}</h3>
  <ul class="plan-details">
    <div class="d-flex mt-3">
      <i class="bi bi-check-circle-fill me-2 text-success"></i>
      <span class="paid-feature-modal-body-text">{{'workspace_upgraded_modal_feature_answers' | translate}}</span>
    </div>
    <div class="d-flex mt-3">
      <i class="bi bi-check-circle-fill me-2 text-success"></i>
      <span class="paid-feature-modal-body-text">{{'workspace_upgraded_modal_feature_insights' | translate}}</span>
    </div>
    <div class="d-flex mt-3">
      <i class="bi bi-check-circle-fill me-2 text-success"></i>
      <span class="paid-feature-modal-body-text">{{'workspace_upgraded_modal_feature_progress' | translate}}</span>
    </div>
  </ul>
  <div style="text-align: center; padding: 1rem">
    <button pButton type="button" class="workspace-upgrade-button"
            style="padding: 10px 50px;  font-family: Poppins, sans-serif; margin-bottom: 3rem;"
            (click)="goToDashboardPlan()">{{'workspace_upgraded_modal_dashboard_btn' | translate}}
    </button>
  </div>
</div>
